import type { ReactNode, UIEvent } from "react"

import isNull from "lodash-es/isNull"
import isUndefined from "lodash-es/isUndefined"

import { Avatar } from "@/3514/components/shared/avatar/avatar.component"
import { EAvatarSize } from "@/3514/components/shared/avatar/avatar.types"
import { Button } from "@/3514/components/shared/button/button.component"
import { RsvpMark } from "@/3514/components/shared/rsvp-mark/rsvp-mark.component"
import { THEME } from "@/3514/theme"
import type { IModuleExcerptAssociatedSessionModel } from "@/3514/types"
import { withPressHandler } from "@/3514/utils"

import { moduleExcerptStyles as classes } from "./module-excerpt.styles"

function renderRsvpButton({
    session,
    handleSessionAction,
    isStub,
    isFullMode,
    isCurrentModule,
    isVisible
}: {
    session: IModuleExcerptAssociatedSessionModel
    handleSessionAction?(event: UIEvent, sessionId: number): void
    isStub: boolean
    isFullMode: boolean
    isCurrentModule: boolean
    isVisible: boolean
}): ReactNode {
    const isSessionPresent: boolean = !isNull(session)

    return isVisible ? (
        <div role="menuitem" tabIndex={-1} className={classes.rsvpContainer()}>
            <Button
                isContainer
                tabIndex={isStub || !isSessionPresent || !isFullMode ? -1 : 0}
                className={classes.rsvp({ isStub, isSessionPresent, isFullMode })}
                {...(isSessionPresent &&
                    !isStub &&
                    isFullMode && {
                        onKeyDown: withPressHandler((event: UIEvent): void => handleSessionAction(event, session.id)),
                        onClick: withPressHandler((event: UIEvent): void => handleSessionAction(event, session.id))
                    })}
            >
                {!isStub && !isUndefined(session?.status) && !isNull(session?.status) && (
                    <RsvpMark status={session?.status} />
                )}

                <Avatar
                    {...((!isSessionPresent || isStub || !session?.coach?.photo) &&
                        !isCurrentModule && { circleFillColor: THEME.COLORS.white })}
                    {...((!isSessionPresent || isStub || !session?.coach?.photo) && {
                        alt: "Coaching Session"
                    })}
                    url={isSessionPresent || !isStub ? session?.coach?.photo : null}
                    size={EAvatarSize._25}
                />
            </Button>
        </div>
    ) : null
}

const helpers = { renderRsvpButton }

export { helpers as moduleExcerptHelpers }
